import React from 'react';
void React;
import IconMonitor from '../../assets/assets/System/Monitor.svg';
import IconMapPin from '../../assets/assets/Navigation/Map.svg';
import IconWarning from '../../assets/assets/Warning/Warning.svg';
import publicHomepageContent from '../../content/publicHomepageContent';

function formatMetricValue(value, { suffix = '', decimals = 0, prefix = '' } = {}) {
  if (!Number.isFinite(Number(value))) {
    return '—';
  }
  const numericValue = Number(value);
  const formatter = new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: numericValue >= 1000 ? 0 : decimals,
    maximumFractionDigits: numericValue >= 1000 ? 0 : decimals,
  });
  return `${prefix}${formatter.format(numericValue)}${suffix}`;
}

function StatCard({ icon, label, value, description }) {
  return (
    <div className="kr-stat-card" role="group" aria-label={label}>
      <img src={icon} alt="" className="kr-stat-icon" aria-hidden="true" />
      <div className="kr-stat-body">
        <div className="kr-stat-value">{typeof value === 'number' ? value : value ?? '—'}</div>
        <div className="kr-stat-label">{label}</div>
        {description ? <div className="kr-stat-description">{description}</div> : null}
      </div>
    </div>
  );
}

// linter hint: ensure helper component is seen as used in all linting configurations
void StatCard;

export default function RobotStatsSection({ stats = {}, loaded = false }) {
  const { statsSection } = publicHomepageContent;
  return (
    <section className="kr-section kr-stats-section" aria-labelledby="stats-heading">
      <div className="kr-shell">
        <div className="kr-section-head">
          <h2 id="stats-heading" className="k-h2">{statsSection.title}</h2>
          <p className="k-body">{statsSection.subtitle}</p>
        </div>
        <div className="kr-stats-grid" role="list">
          <StatCard icon={IconMonitor} label="Actieve robots" value={loaded ? (Number.isFinite(stats.activeRobots) ? stats.activeRobots : '—') : '—'} />
          <StatCard icon={IconMapPin} label="Locaties" value={loaded ? (Number.isFinite(stats.locationsCount) ? stats.locationsCount : '—') : '—'} />
          <StatCard icon={IconMonitor} label="Gereden kilometers" value={loaded ? (Number.isFinite(stats.distanceKm) ? formatMetricValue(stats.distanceKm, { suffix: ' km', decimals: 3 }) : '—') : '—'} />
          <StatCard icon={IconWarning} label="Geschat bestreken oppervlak" value={loaded ? (Number.isFinite(stats.coveredAreaHa) ? formatMetricValue(stats.coveredAreaHa, { suffix: ' ha', decimals: 3 }) : '—') : '—'} description={stats.areaIsEstimated ? 'Geschat op basis van geregistreerde rijafstand en maaibreedte.' : null} />
          <StatCard icon={IconMapPin} label="≈ voetbalvelden" value={loaded ? (Number.isFinite(stats.footballFields) ? formatMetricValue(stats.footballFields, { decimals: 3, prefix: '≈ ' }) : '—') : '—'} description={stats.areaIsEstimated ? 'Geschat bestreken oppervlak.' : null} />
        </div>
      </div>
    </section>
  );
}
